"use client";

import { useEffect, useRef, useState } from "react";

export function useInView<T extends Element>(options?: IntersectionObserverInit & { once?: boolean }) {
  const ref = useRef<T | null>(null);
  const [inView, setInView] = useState(false);
  const once = options?.once ?? true;
  const rootMargin = options?.rootMargin ?? "300px";
  const threshold = options?.threshold ?? 0;

  useEffect(() => {
    if (!('IntersectionObserver' in window)) {
      setInView(true);
      return;
    }
    let obs: IntersectionObserver | null = null;
    const el = ref.current;
    if (!el) return;
    obs = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          setInView(true);
          if (once && obs) {
            try { obs.disconnect(); } catch {}
            obs = null;
          }
          break;
        }
      }
    }, { root: options?.root ?? null, rootMargin, threshold });
    obs.observe(el);
    return () => { try { obs?.disconnect(); } catch {} };
  }, [once, rootMargin, threshold, options?.root]);

  return { ref, inView } as const;
}

